<template>
  <label
    v-if="showFieldNames && (field.name || field.title)"
    :for="field.uuid"
    dir="auto"
    class="label text-2xl"
    :class="{ 'mb-2': !field.description }"
  >
    <MarkdownContent
      v-if="field.title"
      :string="field.title"
    />
    <template v-else>{{ field.name }}</template>
    <template v-if="!field.required">
      ({{ t('optional') }})
    </template>
  </label>
  <div
    v-else
    class="py-1"
  />
  <div
    v-if="field.description"
    dir="auto"
    class="mb-3 px-1"
  >
    <MarkdownContent :string="field.description" />
  </div>
  <AppearsOn :field="field" />
  <div class="items-center flex">
    <input
      type="hidden"
      :name="`values[${field.uuid}]`"
      :value="modelValue"
    >
    <button
      :id="field.uuid"
      class="btn btn-success w-full"
      :disabled="disabled || modelValue"
      @click.prevent="approve"
      @focus="$emit('focus')"
    >
      <IconCheck v-if="modelValue" class="w-5 h-5 mr-2" />
      {{ modelValue ? t('approved') : t('approve') }}
      <template v-if="!field.required && !modelValue">
        ({{ t('optional') }})
      </template>
    </button>
  </div>
</template>

<script>
import { IconCheck } from '@tabler/icons-vue'
import AppearsOn from './appears_on'
import MarkdownContent from './markdown_content'

export default {
  name: 'ApprovalStep',
  components: {
    IconCheck,
    AppearsOn,
    MarkdownContent
  },
  inject: ['t', 'baseUrl'],
  props: {
    submitter: {
      type: Object,
      required: true
    },
    field: {
      type: Object,
      required: true
    },
    modelValue: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showFieldNames: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  methods: {
    approve() {
      this.$emit('update:modelValue', true)
      this.trackApproveDocument()
    },
    trackApproveDocument() {
      fetch(this.baseUrl + '/api/submitter_approve_documents', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          submitter_slug: this.submitter.slug,
          event_type: 'approve_document'
        })
      })
    }
  }
}
</script>
